import DiscordIcon from "./socials/discord";
import GithubIcon from "./socials/github";
import TelegramIcon from "./socials/telegram";
import TwitterIcon from "./socials/twitter";

export function SocialIcon({ url }) {
	const socialUrl = url.replace('www.', '');

	if (socialUrl.startsWith('https://t.me')) {
      return <TelegramIcon />;
   } else if (socialUrl.startsWith('https://x.com') || socialUrl.startsWith('https://twitter.com')) {
      return <TwitterIcon />;
   } else if (socialUrl.startsWith('https://github.com')) {
      return <GithubIcon />;
   } else if (socialUrl.startsWith('https://discord.gg')) {
      return <DiscordIcon />;
   }
}

export function socialArrayToObject(socialUrls: string[]) {
	let socials = {} as { [type: string]: string};

	for (let url of socialUrls) {
      const socialUrl = url.replace('www.', '');
      let type = '';

      if (socialUrl.startsWith('https://t.me')) {
         type = 'telegram';
      } else if (socialUrl.startsWith('https://x.com') || socialUrl.startsWith('https://twitter.com')) {
         type = 'twitter';
      } else if (socialUrl.startsWith('https://github.com')) {
         type = 'github';
      } else if (socialUrl.startsWith('https://discord.gg')) {
         type = 'discord';
      } else if (socialUrl.startsWith('https://coingecko.com')) {
         type = 'coingecko';
      }

      socials[type] = url;
   }

	return socials;
}